// extracted by mini-css-extract-plugin
var _1 = "CalendarGridDayPopoverRowLabels-moduleCalendarGridDayPopoverRowLabels__rTvFe";
var _2 = "CalendarGridDayPopoverRowLabels-moduleclickable__Qlm9g";
var _3 = "CalendarGridDayPopoverRowLabels-moduledetails__OTLYf";
var _4 = "CalendarGridDayPopoverRowLabels-modulelabel__kVlKO";
export { _1 as "CalendarGridDayPopoverRowLabels", _2 as "clickable", _3 as "details", _4 as "label" }
